<template>
  <v-card class="clickable">
    <v-img
      v-if="logo"
      :src="logo"
      :height="item.type === 'event'? '350': 100">
      <v-container 
        fill-height 
        fluid
        @click="goAction">
        <v-layout fill-height>
          <v-flex 
            xs12 
            align-end 
            flexbox>
            <span 
              class="header-title headline white--text" 
              v-text="item.club"/>
          </v-flex>
        </v-layout>
      </v-container>
    </v-img>
    <v-card-text 
      v-else
      :height="item.type === 'event'? '350': 100">
      <v-container 
        fill-height 
        fluid
        @click="goAction">
        <v-layout fill-height>
          <v-flex 
            xs12 
            align-end 
            flexbox>
            <span 
              class="header-title headline white--text" 
              v-text="item.club"/>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
const debug = require('debug')('OD::ClubCard')

export default {
  name: 'ClubCard',
  props: {
    item: {
      type: Object,
      required: true,
    },
    isClubAdmin: {
      type: Boolean,
      required: true,
    },
    year: {
      type: String,
      default: '',
    },
    week: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      storeModule: 'club',
    }
  },
  computed: {
    logo() {
      if (this.item.logo && this.item.logo.value) {
        return this.item.logo.value
      }
      return null
    },
  },
  created() {
    debug('XXXX', this.item)
  },
  methods: {
    goAction() {
      if (this.year && this.week) {
        this.$router.push({
          name: 'WeekMatches',
          params: { clubId: this.item.id, year: this.year, week: this.week },
        })
      } else {
        this.$router.push({
          name: 'Club',
          params: { clubId: this.item.id },
        })
      }
    },
  },
}
</script>

<style>
.clubs-logo {
  width: 100%;
}
.header-title {
  background-color: #334;
  opacity: 0.8;
  padding: 5px;
}
.clickable {
  cursor: pointer;
}
</style>
